var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mirror"},[_c('div',{staticClass:"wrap",style:({ width: _vm.width + 'px', height: _vm.width + 'px' })},[_c('div',{ref:"truth",style:({ width: '100%', height: '100%' }),on:{"mousemove":_vm.move,"mouseenter":_vm.showMagnify,"mouseleave":_vm.hideMagnify}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMask),expression:"showMask"}],ref:"mask",staticClass:"mask",style:({
          width: _vm.width / 2 + 'px',
          height: _vm.width / 2 + 'px',
          left: _vm.maskPosition.x + 'px',
          top: _vm.maskPosition.y + 'px',
        })}),_vm._v(" "),_c('img',{attrs:{"src":_vm.picList[_vm.picIndex],"draggable":"false"}})]),_vm._v(" "),(_vm.isShowVirtual)?_c('div',{ref:"virtual",staticClass:"virtual",style:({ width: _vm.width + 'px', height: _vm.width + 'px' })},[_c('div',{ref:"bigPic",staticClass:"big",style:({
          position: 'absolute',
          width: 2 * _vm.width + 'px',
          height: 2 * _vm.width + 'px',
          backgroundSize: '100% 100%',
          backgroundImage: ("url(" + (_vm.picList[_vm.picIndex]) + ")"),
          left: _vm.percent.x,
          top: _vm.percent.y,
        })})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f72998dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/amplification/amplification.vue
// module id = null
// module chunks = 